import uuidMixin from '@/assets/js/mixin/uuid'

export default function ariaMixin(ariaComponent) {
  return {
    mixins: [uuidMixin],
    methods: {
      ariaUid(ariaElement, ariaIdx) {
        const castAriaIdx = ariaIdx == null ? '' : ariaIdx.toString()
        const parts = [ariaComponent, this.uuid, ariaElement, castAriaIdx]
        return `${parts.filter(Boolean).join('-')}`
      },
    },
  }
}
